import { useFormikContext } from "formik";
// import { Button } from "./ui/button";

import { Input } from "./ui/input";
import Combobox from "./Combobox";
import CustomLabelText from "./CustomLabelText";
import { Label } from "./ui/label";
import { DateInputPicker } from "./DateInputPicker";
// import UserSelect from "./UserSelect";
// import { Loader2 } from "lucide-react";
import moment from "moment";

export default function VerificationRow({
  index,
  values,
  errors,
  push,
  remove,
  verificationMethods,
  verificationTypes,
  userList,
  setUserList,
  setUserLoading,
  userLoading,
  organizationData,
  userListing,
  mainData
}) {
  const { setFieldValue } = useFormikContext();

  const method = values.verifications[index]?.method;
  const selectedTypeId = values.verifications[index]?.type;

  const selectedType = verificationTypes?.find((t) => t.id === selectedTypeId);

  // const methods = values.verifications || [];

  // const selectedMethods = methods?.map((v) => v?.method)?.filter(Boolean);

  const filteredMethods = verificationMethods.filter((m) => {
    // if ((m.value === 3 || m.value === 5) && selectedMethods.includes(m.value)) {
    //   return false;
    // }
    return true;
  });

  return (
    <div className="border rounded-xl p-5 space-y-5">
      {/* Header */}
      <div className="flex items-start justify-between">
        <h5 className="font-semibold">Document {index + 1}</h5>

        <div className="flex gap-2">
          {/* {values.verifications.length < 2 && !mainData?.kyc?.status && (
            <Button
              type="button"
              size="sm"
              variant="outline"
              onClick={() =>
                push({
                  method: "",
                  type: "",
                })
              }
            >
              Add
            </Button>
          )} */}

          {/* {values.verifications.length > 1 && !mainData?.kyc?.status && (
            <Button
              type="button"
              size="sm"
              variant="destructive"
              onClick={() => remove(index)}
            >
              Delete
            </Button>
          )} */}
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        {/* METHOD */}

        <div className="space-y-2">
          <Label htmlFor="trust_id">
            <CustomLabelText
              required={false}
              labelText="Verification Method"
              errorField={errors?.verifications?.[index]?.method}
            />
          </Label>
          <Combobox
            options={filteredMethods.map((t) => ({
              label: t.title,
              value: t.value,
            }))}
            value={method || ""}
            placeholder="Select method"
            onChange={(value) => {
              setFieldValue(`verifications.${index}.method`, Number(value));

              if (Number(value) === 2) {
                setFieldValue(`verifications.${index}.type`, "");
              }
            }}
            disabled={values?.verifications?.[index]?.verified_using ? true : false}
            className={
              errors?.verifications?.[index]?.method &&
              `focus-visible:ring-red-500 border-red-500`
            }
          />
        </div>

        {/* DOCUMENT TYPE */}

        <div className="space-y-2">
          <Label htmlFor="trust_id">
            <CustomLabelText
              required={false}
              labelText="Document Id"
              errorField={errors?.verifications?.[index]?.type}
            />
          </Label>
          <Combobox
            options={verificationTypes.map((t) => ({
              label: t.label,
              value: t.id,
            }))}
            value={selectedTypeId || ""}
            placeholder="Select method"
            onChange={(value) => {
              setFieldValue(`verifications.${index}.type`, value);
            }}
            disabled={values?.verifications?.[index]?.verified_using ? true : false}
            className={
              errors?.verifications?.[index]?.type &&
              `focus-visible:ring-red-500 border-red-500`
            }
          />
        </div>

        {/* DOCUMENT NUMBER */}
        {/* {method === 1 && (
          <div className="space-y-2">
            <Label htmlFor="trust_id">
              <CustomLabelText
                required={false}
                labelText="Document Number"
                errorField={errors?.verifications?.[index]?.document_number}
              />
            </Label>
            <Input
              placeholder="Document Number"
              value={values?.verifications?.[index]?.document_number}
              onChange={(e) =>
                setFieldValue(
                  `verifications.${index}.document_number`,
                  e.target.value,
                )
              }
              disabled={values?.verifications?.[index]?.verified_using ? true : false}
              className={
                errors?.verifications?.[index]?.document_number &&
                `focus-visible:ring-red-500 border-red-500`
              }
            />
          </div>
        )} */}

        {/* METHOD 3 Dynamic Fields */}
        {method === 3 &&
          selectedType?.fields?.map((f) => (
            <div key={f.key} className="space-y-2">
              <Label htmlFor="trust_id">
                <CustomLabelText
                  required={false}
                  labelText={f.label}
                  errorField={
                    errors?.verifications?.[index]?.dynamicFields?.[f.key]
                  }
                />
              </Label>

              {f.inputType === "dropdown" ? (
                <Combobox
                  placeholder={`Select ${f.label}`}
                  value={values.verifications[index]?.dynamicFields?.[f.key]}
                  options={f.options.map((opt) => ({
                    label: opt.label,
                    value: opt.value,
                  }))}
                  onChange={(value) =>
                    setFieldValue(
                      `verifications.${index}.dynamicFields.${f.key}`,
                      value,
                    )
                  }
                  disabled={values?.verifications?.[index]?.verified_using ? true : false}
                  className={
                    errors?.verifications?.[index]?.dynamicFields?.[f.key] &&
                    `focus-visible:ring-red-500 border-red-500`
                  }
                />
              ) : f.inputType === "date" ? (
                values?.verifications?.[index]?.verified_using ? (
                  <Input
                    placeholder={f.label}
                    value={
                      values?.verifications?.[index]?.dynamicFields?.[f.key] ? moment(values?.verifications?.[index]?.dynamicFields?.[f.key])?.format("DD-MM-YYYY") : ""
                    }
                    readonly
                    disabled={values?.verifications?.[index]?.verified_using ? true : false}
                    className={
                      errors?.verifications?.[index]?.dynamicFields?.[f.key] &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                  />
                ) : (
                  <DateInputPicker
                    date={
                      values?.verifications[index].dynamicFields?.[f.key]
                        ? values?.verifications[index].dynamicFields?.[f.key]
                        : ""
                    }
                    onSelect={(e) => {
                      setFieldValue(
                        `verifications.${index}.dynamicFields.${f.key}`,
                        e,
                      );
                    }}
                    inputClassName="w-full"
                    className={
                      errors?.verifications?.[index]?.dynamicFields?.[f.key] &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabledDate={f?.future_date ? {} : { after: new Date() }}
                  />
                )
              ) : (
                <Input
                  placeholder={f.label}
                  value={values?.verifications?.[index]?.dynamicFields?.[f.key]}
                  onChange={(e) =>
                    setFieldValue(
                      `verifications.${index}.dynamicFields.${f.key}`,
                      e.target.value,
                    )
                  }
                  disabled={values?.verifications?.[index]?.verified_using ? true : false}
                  className={
                    errors?.verifications?.[index]?.dynamicFields?.[f.key] &&
                    `focus-visible:ring-red-500 border-red-500`
                  }
                />
              )}
            </div>
          ))}

        {/* Verification Date */}

        {/* <div className="space-y-2">
          <Label htmlFor="trust_id">
            <CustomLabelText
              required={false}
              labelText="Verification Date"
              errorField={errors?.verifications?.[index]?.date_verified}
            />
          </Label>
          {values?.verifications?.[index]?.verified_using ? (
            <Input
              value={values?.verifications?.[index]?.date_verified ? moment(values?.verifications?.[index]?.date_verified)?.format("DD-MM-YYYY") : ""}
              readonly
              disabled={values?.verifications?.[index]?.verified_using ? true : false}
            />
          ) : (
            <DateInputPicker
              date={
                values?.verifications[index]?.date_verified
                  ? values?.verifications[index]?.date_verified
                  : ""
              }
              onSelect={(e) => {
                setFieldValue(`verifications.${index}.date_verified`, e);
              }}
              inputClassName="w-full"
              className={""}
              disabledDate={{ after: new Date() }}
            />
          )}
        </div> */}

        {/* Verified By */}

        {/* <div className="min-w-0">
          <Label htmlFor="verified_by">
            <CustomLabelText
              labelText="Verified By"
              errorField={errors?.verified_by}
            />
          </Label>
          <div className="relative mt-2">
            <UserSelect
              orgId={organizationData?.organizationId}
              frameworkData={userListing} // List of vendors
              optionType="User"
              handleSelect={(e) => {
                setFieldValue(`verifications.${index}.verified_by`, e);
              }}
              name="verified_by"
              disabled={values?.verifications?.[index]?.verified_using ? true : false}
              initialValue={
                values?.verifications?.[index]?.verified_by
                  ? values?.verifications?.[index]?.verified_by
                  : ""
              }
              authUser={true}
              setUserList={setUserList}
              setUserLoading={setUserLoading}
              onClear={() => {
                setFieldValue(`verified_by`, "");
              }}
              className={
                errors?.verified_by &&
                `focus-visible:ring-red-500 border-red-500`
              }
              loading={userLoading}
            />
            {userLoading && (
              <span className="absolute top-2 right-2 animate-spin">
                <Loader2 width={20} height={20} />
              </span>
            )}
          </div>
        </div> */}

        {/* VERIFIED */}

        {/* <div className="space-y-2">
          <Label htmlFor="trust_id">
            <CustomLabelText
              required={false}
              labelText="Verified"
              errorField={errors?.verifications?.[index]?.verified}
            />
          </Label>

          <Combobox
            options={[
              { label: "Yes", value: 1 },
              { label: "No", value: 0 },
            ]}
            disabled={values?.verifications?.[index]?.verified_using ? true : false}
            value={values.verifications[index]?.verified}
            placeholder="Select"
            onChange={(value) =>
              setFieldValue(`verifications.${index}.verified`, value)
            }
          />
        </div> */}
      </div>
    </div>
  );
}
